<div class="account-setting container-fluid p-0 bg-light-gray">
  <div class="row row-cols-1 m-0 gy-2">
    <div class="col mt-0 p-0 bg-primary-white navbar-spacer">
      <app-navbar class="fixed-top"></app-navbar>
    </div>
    <div class="col px-4 py-3 bg-primary-white">
      <div class="fs-5 text-secondary-purple mb-4">
        {{ 'app.accountSetting.updatePassword' | translate }}
      </div>
      <form
        [formGroup]="updatePwdForm"
        (ngSubmit)="onSubmit()"
        class="row row-cols-1 gy-3"
      >
        <div class="col">
          <label for="email" class="form-label">
            {{ 'app.login.email' | translate }}
          </label>
          <input
            type="email"
            class="form-control"
            id="email"
            placeholder="{{ userEmail }}"
            readonly
          />
        </div>
        <div class="col">
          <label for="currentPassword" class="form-label">
            {{ 'app.accountSetting.currentPassword' | translate }}
          </label>
          <input
            formControlName="currentPassword"
            type="{{ isShowCurrentPwd.value ? 'text' : 'password' }}"
            class="form-control"
            id="currentPassword"
            placeholder="{{ 'app.accountSetting.pleaseFill' | translate }}"
            autocomplete="on"
          />
          <div class="text-danger">
            @let currentPwd = updatePwdForm.get('currentPassword');
            @if (
              currentPwd?.invalid && (currentPwd?.dirty || currentPwd?.touched)
            ) {
              @if (currentPwd?.hasError('required')) {
                {{ 'app.accountSetting.passwordRequired' | translate }}
              }
            }
          </div>
        </div>
        <div class="col">
          <div class="form-check">
            <input
              [formControl]="isShowCurrentPwd"
              type="checkbox"
              class="form-check-input"
              id="showCurrentPwd"
            />
            <label for="showCurrentPwd" class="form-check-label">
              {{ 'app.accountSetting.showPassword' | translate }}
            </label>
          </div>
        </div>
        <div class="col">
          <label for="newPassword" class="form-label">
            {{ 'app.accountSetting.newPassword' | translate }}
          </label>
          <input
            formControlName="newPassword"
            type="{{ isShowNewPwd.value ? 'text' : 'password' }}"
            class="form-control"
            id="newPassword"
            placeholder="{{ 'app.accountSetting.pleaseFill' | translate }}"
            autocomplete="on"
          />
          <div class="text-danger">
            @let newPwd = updatePwdForm.get('newPassword');
            @if (newPwd?.invalid && (newPwd?.dirty || newPwd?.touched)) {
              @if (newPwd?.hasError('required')) {
                {{ 'app.accountSetting.passwordRequired' | translate }}
              }
              @if (newPwd?.hasError('passwordPattern')) {
                {{ 'validation.passwordPattern' | translate }}
              }
            }
          </div>
        </div>
        <div class="col">
          <div class="form-check">
            <input
              [formControl]="isShowNewPwd"
              type="checkbox"
              class="form-check-input"
              id="showNewPwd"
            />
            <label for="showNewPwd" class="form-check-label">
              {{ 'app.accountSetting.showPassword' | translate }}
            </label>
          </div>
        </div>
        <div class="col">
          <label for="confirmPassword" class="form-label">
            {{ 'app.accountSetting.confirmPassword' | translate }}
          </label>
          <input
            formControlName="confirmPassword"
            type="{{ isShowConfirmPwd.value ? 'text' : 'password' }}"
            class="form-control"
            id="confirmPassword"
            placeholder="{{ 'app.accountSetting.pleaseFill' | translate }}"
            autocomplete="on"
          />
          <div class="text-danger">
            @let confirmPwd = updatePwdForm.get('confirmPassword');
            @if (
              confirmPwd?.invalid && (confirmPwd?.dirty || confirmPwd?.touched)
            ) {
              @if (confirmPwd?.hasError('required')) {
                {{ 'app.accountSetting.passwordRequired' | translate }}
              } @else if (confirmPwd?.hasError('valueNotEqual')) {
                {{ 'app.accountSetting.passwordNotMatch' | translate }}
              }
            }
          </div>
        </div>
        <div class="col">
          <div class="form-check">
            <input
              [formControl]="isShowConfirmPwd"
              type="checkbox"
              class="form-check-input"
              id="showConfirmPwd"
            />
            <label for="showConfirmPwd" class="form-check-label">
              {{ 'app.accountSetting.showPassword' | translate }}
            </label>
          </div>
        </div>
        <div class="col">
          <div class="px-0">
            <button
              [disabled]="isPwdChanging"
              type="submit"
              class="btn btn-primary w-100 mb-3"
            >
              {{ 'app.accountSetting.submit' | translate }}
              @if (isPwdChanging) {
                <div class="spinner-border text-light spinner-border-sm"></div>
              }
            </button>
            <button type="reset" class="btn btn-outline-primary w-100">
              {{ 'app.accountSetting.cancel' | translate }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
